import React from 'react';
import Footer from '../Footer'; // Ensure correct path to Footer component
import image1 from '../../images/Images Webp/decoupagegateau.webp'

const Blog5 = () => {
    return (
        <>
            <div className="min-h-screen p-8 bg-gray-50">
                <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-xl p-8">
                    <h1 className="text-orange-600 text-4xl font-extrabold mb-8 text-center">
                        Mariage avec un non-musulman : le périlleux périple administratif des Tunisiennes, raconté avec une touche d&apos;humour et d&apos;émotion
                    </h1>
                    <p className="text-gray-700 text-lg mb-8">
                        Dans le vibrant tapestry de la société tunisienne, l&apos;amour ne connaît pas de frontières, transcendant les clivages culturels et religieux. Cependant, lorsque... (Votre texte continue ici)
                    </p>

                    <img src={image1} alt="Image description 1" className="w-full h-auto mb-8 rounded-lg shadow-md" />

                    <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">
                        Le Parcours du Combattant Administratif : Un Marathon Paperassier
                    </h2>
                    <p className="text-gray-700 mb-6">
                        Le premier obstacle consiste à obtenir le &quot;certificat de célibat&quot; auprès de l&apos;ambassade de Tunisie dans le pays du fiancé. Ce document apparemment simple devient... (Votre texte continue ici)
                    </p>

                    <img src={image1} alt="Image description 2" className="w-full h-auto mb-8 rounded-lg shadow-md" />

                    <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">
                        L&apos;Amour Défie les Règles : Une Aventure Administrative Pleine d&apos;Émotions
                    </h2>
                    <p className="text-gray-700 mb-6">
                        Malgré ces défis intimidants, les Tunisiennes persévèrent, leur amour pour leur partenaire alimentant leur détermination à surmonter les obstacles administratifs... (Votre texte continue ici)
                    </p>

                    <img src={image1} alt="Image description 3" className="w-full h-auto mb-8 rounded-lg shadow-md" />

                    <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">
                        Un Appel au Changement : Vers des Mariages Interreligieux Simplifiés
                    </h2>
                    <p className="text-gray-700 mb-6">
                        Le sort des Tunisiennes dans les mariages interreligieux souligne la nécessité de réformes juridiques qui rationalisent le processus administratif... (Votre texte continue ici)
                    </p>

                    <img src={image1} alt="Image description 4" className="w-full h-auto mb-8 rounded-lg shadow-md" />

                    <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">
                        Conclusion : Un Message d&apos;Espoir et d&apos;Inspiration
                    </h2>
                    <p className="text-gray-700">
                        L&apos;histoire des Tunisiennes qui se marient avec des non-musulmans est un rappel que l&apos;amour peut surmonter tous les obstacles, même les plus bureaucratiques... (Votre texte continue ici)
                    </p>

                    <img src="/mariagePhotos/decoupagegateau.jpeg" alt="Image description 5" className="w-full h-auto mb-8 rounded-lg shadow-md" />
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Blog5;
